import {
  PROTOCOL_SLIDE_TYPES,
  fetchProtocolScene,
} from '@learningblocks/protocol-constants/lib/Utilities';
import {updateSlideInList} from '../../utilities';

export function slideOneSetAsNextStep(state, payload) {
  return {
    ...state,
    protocolSection: updateDesignSection(state.protocolSection, payload),
  };
}

function updateDesignSection(protocolSection, payload) {
  const allSlides = updateAllSlides(protocolSection.allSlides, payload);
  return {
    ...protocolSection,
    allSlides,
  };
}

function fetchVacantOption(designSlideOne) {
  const vacantOption = designSlideOne.options.reduce((vacant, option) => {
    if (option.droppedId === null && option.position !== null) {
      if (vacant) {
        if (vacant.position > option.position) {
          vacant = option;
        }
      } else {
        vacant = option;
      }
    }
    return vacant;
  }, null);
  return vacantOption;
}

function updateAllSlides(allSlides, payload) {
  let designSlideOne = fetchProtocolScene(allSlides, PROTOCOL_SLIDE_TYPES.ONE);
  let slideOptions = designSlideOne.options;
  let incorrects = designSlideOne.incorrects;
  let vacantOption = fetchVacantOption(designSlideOne);
  if (vacantOption && vacantOption.hasOwnProperty('droppedId')) {
    vacantOption = {...vacantOption, droppedId: payload.componentID};
    slideOptions = updateVacantInOptions(slideOptions, vacantOption);
    incorrects = updateIncorrects(incorrects, vacantOption);
  }
  designSlideOne = {
    ...designSlideOne,
    incorrects,
    options: slideOptions,
  };
  const updatedSlides = updateSlideInList(allSlides, designSlideOne);
  return updatedSlides;
}

function updateVacantInOptions(allOptions, vacantOption) {
  return allOptions.map((option) => {
    if (option.id === vacantOption.id) {
      option = vacantOption;
      if (option.id !== vacantOption.droppedId) {
        option.wrongDrops += 1;
      }
    }
    return {...option};
  });
}

function updateIncorrects(incorrects, vacantOption) {
  if (vacantOption.droppedId !== vacantOption.id) {
    return incorrects + 1;
  } else {
    return incorrects;
  }
}
